import { GoogleCalendarActions } from './actions'
import { GoogleCalendarGetters } from './getters'
import { GoogleCalendarMutations } from './mutations'
import { GoogleCalendarState } from './state'

export const GOOGLE_CALENDAR_NAMESPACE = 'googleCalendar'

export const GoogleCalendar = {
  actions: GoogleCalendarActions,
  getters: GoogleCalendarGetters,
  mutations: GoogleCalendarMutations,
  namespaced: true,
  state: GoogleCalendarState,
}
